import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/new/AboutStatCard/TargetedResults.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/new/SanjeevaniPhase/SanjeevaniPhase.tsx");
